
import { axios } from '../lib/axios/axios';
import { BASE_PROJECT_PATH, generateRoutePath } from '../routes';
import { PREFIX_URL } from './config';

const URLS = {}

URLS.BASE_URL = `${PREFIX_URL}/project`;
URLS.NEW_BASE_URL = `${PREFIX_URL}/projects`;
URLS.DETAILS = `${URLS.BASE_URL}/detail/:projectId`;
URLS.CHECK_NAME = `${URLS.BASE_URL}/checkName`;
URLS.CHECK_EMAIL = `${URLS.NEW_BASE_URL}/checkEmail`;
URLS.CHECK_EXISTING_EMAIL = `${PREFIX_URL}${BASE_PROJECT_PATH}/change-email-allowed`;

export const checkName = async(params) => {
    return await axios.get(URLS.CHECK_NAME, {params, showError: false })
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        })
}

export const checkEmail = async(params) => {
    return await axios.get(URLS.CHECK_EMAIL, {params, showError: false })
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        })
}

export const checkExistingEmail = async(params) => {
    return await axios.get(generateRoutePath(URLS.CHECK_EXISTING_EMAIL, {projectId: params.projectId }), {
        params: {
            email: params.email
        }, 
        showError: false 
    })
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        })
}


export const fetchDetails = (projectId, params = {}) => {
    let qs = {};

    if (Object.keys(params).length > 0) {
        qs = {
            info: params.info
        }
    }

    const url = generateRoutePath(URLS.DETAILS, {projectId}, qs);

    return axios.get(url, {params});
}
